const TOPICS = [
  { name: '繁华似锦大结局', heat: '128万讨论' },
  { name: '逆光之恋CP', heat: '96万讨论' },
  { name: '国产悬疑剧推荐', heat: '85万讨论' },
  { name: '高分韩剧排行榜', heat: '73万讨论' },
  { name: '长安十二时辰细节', heat: '68万讨论' },
  { name: '暑期追剧清单', heat: '62万讨论' },
  { name: 'TVB经典重温', heat: '55万讨论' },
  { name: '古装剧服化道', heat: '49万讨论' },
  { name: '请回答2028名场面', heat: '43万讨论' },
  { name: '山海情演技炸裂', heat: '38万讨论' },
  { name: '风起洛阳剧情解析', heat: '35万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
              社区热议
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              热门话题
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              加入剧迷讨论，分享你的观剧感受与独到见解
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {TOPICS.map((topic, i) => {
              const sizes = ['md', 'lg', 'sm', 'md', 'lg', 'sm', 'md', 'sm', 'md', 'sm', 'md'];
              const sizeClass = sizes[i];
              return (
                <div
                  key={i}
                  className={`group relative bg-background-100 border border-background-200/40 hover:border-primary-500/20 hover:bg-background-50 rounded-xl px-4 py-3 md:px-5 md:py-3.5 transition-all duration-200 cursor-pointer ${
                    sizeClass === 'lg' ? 'md:px-6' : sizeClass === 'sm' ? 'md:px-3.5' : ''
                  }`}
                >
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm text-foreground-700 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                      # {topic.name}
                    </span>
                  </div>
                  <span className="block text-xs text-foreground-400 mt-1">{topic.heat}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}